module.exports = __webpack_public_path__ + "static/media/creative-commons.c62130bb.svg";